import o from"styled-components";const e=o.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	border-radius: ${({borderRadius:o})=>`${o}px`};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	background-color: ${({backgroundColor:o})=>o};
	color: ${({color:o})=>o};
	padding: 16px;
	height: 100%;
	box-sizing: border-box;
	justify-content: space-between;
`,i=o.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`,t=o.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,l=o.h1`
	font-size: 22px;
	margin: 0;
	font-weight: 600;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,r=o.p`
	font-size: 14px;
	margin: 0;
	font-weight: 400;
	opacity: 0.6;
	line-height: 18px;
	outline: none;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,n=o.div`
	position: relative;
	font-size: 30.5px;
	cursor: pointer;
`,c=o.div`
	display: flex;
	align-items: center;
	justify-content: ${({hasLink:o})=>o?"space-between":"flex-end"};
`,d=o.span`
	font-size: 14px;
	font-weight: 400;
	width: 80%;
	color: ${({color:o})=>o};
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,p=o.div`
	display: grid;
	place-content: center;
	background-color: ${({color:o})=>o};
	border-radius: 9999px;
	width: 24px;
	height: 24px;
`,a=o.div`
	display: grid;
	place-content: center;
	width: fit-content;

	svg {
		fill: ${({color:o})=>o};

		path {
			fill: ${({color:o})=>o};
		}
		circle {
			fill: ${({color:o})=>o};
		}
		rect {
			fill: ${({color:o})=>o};
		}
	}
`;export{p as CardArrowContainer,i as CardBody,e as CardContainer,t as CardContentContainer,n as CardEmoji,c as CardFooter,l as CardHeading,a as CardIconContainer,d as CardLink,r as CardParagraph};
